export default {
  methods: {
    getEstablecimiento() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var identity = JSON.parse(localStorage.getItem("usuario"));
      var idEstablecimiento = app.view.main.router.currentRoute.params.idEstablecimiento;
      var url = window.global.url + "establecimientos/" + idEstablecimiento;
      app.preloader.show();
      app.request.json(url, function (response) {
        console.log(response);

        if (response.code == 200) {
          var establecimiento = response.establecimiento;
          sessionStorage.setItem('_establecimiento', JSON.stringify(establecimiento));
          app.preloader.hide();
        } else {
          app.preloader.hide();
          app.dialog.alert("Error");
        }
      }, function (xhr, status) {
        app.preloader.hide();
        console.log(xhr);
        console.log(status);
        app.dialog.alert("Error general");
      });
    }

  },
  on: {
    pageInit() {// var self = this;
      // var app = self.$app;
      // var $ = self.$;
      // self.getEstablecimiento();
    }

  },
  id: 'e3e26d92f9',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=mis-datos><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class=navbar-inner><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Atrás</span></a></div><div class="title sliding">Configuración</div><div class=right></div></div></div><!-- Scrollable page content--><div class=page-content><div class=block><p>Seleccioná una opción para cambiar la configuración.</p></div><div class=list><ul><li><a href=tipomesa-mod class="item-link item-content"><div class=item-media><i class="icon fas fa-border-all"></i></div><div class=item-inner><div class=item-title>Editar tipo de origen de pedido</div></div></a></li><li><a href=pedidoswhatsapp-mod class="item-link item-content"><div class=item-media><i class="icon fab fa-whatsapp"></i></div><div class=item-inner><div class=item-title>Recibir pedidos al Whatsapp</div></div></a></li><li><a href=tiposenvio-mod class="item-link item-content"><div class=item-media><i class="icon far fa-truck"></i></div><div class=item-inner><div class=item-title>Tipos de envío</div></div></a></li><li><a href=desactivar-carrito class="item-link item-content"><div class=item-media><i class="icon far fa-shopping-cart"></i></div><div class=item-inner><div class=item-title>Desactivar carrito</div></div></a></li><li><a href=vistaclasicacategorias-mod class="item-link item-content"><div class=item-media><i class="icon far fa-list-ul"></i></div><div class=item-inner><div class=item-title>Vista clásica de categorías</div></div></a></li><li><a href=mostrartotal-mod class="item-link item-content"><div class=item-media><i class="icon fas fa-dollar-sign"></i></div><div class=item-inner><div class=item-title>Ocultar precio total</div></div></a></li><li><a href=ocultar-nombres-destacados class="item-link item-content"><div class=item-media><i class="icon far fa-eye-slash"></i></div><div class=item-inner><div class=item-title>Ocultar nombre productos destacados</div></div></a></li><li><a href=ocultar-nombre-categorias class="item-link item-content"><div class=item-media><i class="icon far fa-eye-slash"></i></div><div class=item-inner><div class=item-title>Ocultar nombre de categorías</div></div></a></li><li><a href=ocultar-direccion class="item-link item-content"><div class=item-media><i class="icon far fa-eye-slash"></i></div><div class=item-inner><div class=item-title>Ocultar dirección del local</div></div></a></li><li><a href=ocultar-horarios class="item-link item-content"><div class=item-media><i class="icon far fa-eye-slash"></i></div><div class=item-inner><div class=item-title>Ocultar horarios del local</div></div></a></li><li><a href=publicar-en-web class="item-link item-content"><div class=item-media><i class="icon far fa-newspaper"></i></div><div class=item-inner><div class=item-title>Publicar mi local en Webmenú</div></div></a></li><li><a href=desactivar-menu class="item-link item-content"><div class=item-media><i class="icon far fa-store-slash"></i></div><div class=item-inner><div class=item-title>Desactivar menú</div></div></a></li></ul></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};